// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2fAcS","col":"styles_col__1RYEJ"};